import { Field, Form, Formik } from "formik";
import "moment-timezone";
import React, { useEffect, useState } from "react";
import { Button, Checkbox, ControlLabel } from "react-bootstrap";
import InputMask from 'react-input-mask';
import { useHistory, useParams } from "react-router";
import { Link } from 'react-router-dom';
import Alert from "react-s-alert";
import * as Yup from "yup";
import FormikFormControl from "../../Shared/Forms/FormikFormControl";
import FormikTextAreaControl from '../../Shared/Forms/FormikTextAreaControl';
import UsersService from "../../utils/UsersService";
import { userRoles } from "./utility";

const User = () => {
  const history = useHistory();
  const { id } = useParams()
  const [user, setUser] = useState()

  useEffect(() => {
    UsersService.get(id).then((data) => {
      setUser(data);
    });
  }, [id])

  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .required("is required")
      .max(30, "maximum 30 characters"),
    last_name: Yup.string()
      .required("is required")
      .max(30, "maximum 30 characters"),
    phone: Yup.string(),
    admin_notes: Yup.string().max(1000, "maximum 1000 characters"),
    tcs_work_hours: Yup.string().max(100, "maximum 100 characters"),
  });

  if (!user) return null

  return (
    <Formik
      initialValues={{
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        email: user.email,
        roles: user.roles || [],
        phone: user.phone || "",
        region: user.region || "VIC",
        admin_notes: user.admin_notes || "",
        is_locked_out: user.is_locked_out || "",
        options: user.options || { tcs_priority: 3 },
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);

        UsersService.update(id, values).then((data) => {
          Alert.success("Updated user");
          history.push(`/m1/users`);
        });
      }}
      render={({
        errors,
        touched,
        isValid,
        isSubmitting,
        values,
        setFieldValue,
        setFieldTouched,
      }) => (
        <>
          <h3 className="first-title mt-0 mb-3">
            <Link to={`/m1/users`}>Users</Link><i className='fal fa-caret-right' style={{marginLeft:10, marginRight: 10}}></i>
            {user.first_name} {user.last_name}{" "}
            <span style={{ fontSize: 18 }}>&lt;{user.email}&gt;</span>
            <small style={{ marginLeft: 40 }}>
              <Link to={`/m1/users/${user.id}/schedule`}>edit schedule</Link>
            </small>
          </h3>
          <Form>
            <div style={{ display: "flex" }}>
              <div style={{ paddingRight: 40 }}>
                <div style={{ display: "flex" }}>
                  <FormikFormControl
                    fieldName="first_name"
                    errors={errors}
                    touched={touched}
                    style={{ marginRight: 20, width: 250 }}
                  >
                    <ControlLabel>First Name</ControlLabel>
                    <Field
                      type="text"
                      name="first_name"
                      className="form-control"
                    />
                  </FormikFormControl>
                  <FormikFormControl
                    fieldName="last_name"
                    errors={errors}
                    touched={touched}
                    style={{ marginRight: 20, width: 250 }}
                  >
                    <ControlLabel>Last Name</ControlLabel>
                    <Field
                      type="text"
                      name="last_name"
                      className="form-control"
                    />
                  </FormikFormControl>
                  <FormikFormControl
                    fieldName="phone"
                    errors={errors}
                    touched={touched}
                    style={{ marginRight: 20, width: 140 }}
                  >
                    <ControlLabel>Phone Number</ControlLabel>
                    <Field
                      type="text"
                      name="phone"
                      className="form-control"
                      render={({ field }) => {
                        return (
                          <InputMask
                            mask="9999 999 999"
                            {...field}
                            className={`form-control ${errors["phone"] &&
                              touched["phone"] &&
                              "is-invalid"}`}
                          />
                        );
                      }}
                    />
                  </FormikFormControl>
                  <FormikFormControl
                    fieldName="region"
                    errors={errors}
                    touched={touched}
                    style={{ width: 120 }}
                  >
                    <ControlLabel>Region</ControlLabel>
                    <Field
                      component="select"
                      name="region"
                      className="form-control"
                    >
                      <option value="VIC">VIC</option>
                      <option value="NSW">NSW</option>
                      <option value="QLD">QLD</option>
                      <option value="SA">SA</option>
                      <option value="WA">WA</option>
                      <option value="TAS">TAS</option>
                      <option value="NT">NT</option>
                      <option value="ACT">ACT</option>
                    </Field>
                  </FormikFormControl>
                </div>

                <FormikTextAreaControl
                  fieldLabel="Admin Notes"
                  fieldName="admin_notes"
                  errors={errors}
                  touched={touched}
                  textareaHeight={100}
                />

                <div className="mt-4">
                  <Button
                    onClick={() => history.push("/m1/users")}
                    bsSize="small"
                    className="mr-2"
                  >
                    Close
                  </Button>
                  <Button
                    disabled={isSubmitting}
                    type="submit"
                    bsStyle="primary"
                    bsSize="small"
                  >
                    Update User
                  </Button>
                </div>
              </div>
              <div style={{ paddingRight: 40 }}>
                <div className="form-group">
                  <FormikFormControl
                    fieldName="is_locked_out"
                    errors={errors}
                    touched={touched}
                    style={{ width: 200 }}
                  >
                    <ControlLabel>Status</ControlLabel>
                    <Field
                      component="select"
                      name="is_locked_out"
                      className="form-control"
                    >
                      <option value={false}>Active</option>
                      <option value={true}>Locked Out</option>
                    </Field>
                  </FormikFormControl>
                  <label>Roles</label>
                  <br />
                  {Object.keys(userRoles).map((role) => (
                    <Checkbox
                      key={role}
                      checked={values.roles.includes(role)}
                      onChange={() => {
                        const current = [...values.roles];
                        if (current.indexOf(role) !== -1) {
                          current.splice(current.indexOf(role), 1);
                        } else {
                          current.push(role);
                        }
                        setFieldValue("roles", current);
                      }}
                    >
                      {userRoles[role]}
                    </Checkbox>
                  ))}
                </div>
              </div>
            </div>
          </Form>
        </>
      )}
    />
  );
};

export default User;
